<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title" v-if="!showAppraisal && this.mode != this.$FORM_MODE_HISTORY">
                            [{{ mode }}] {{ $t('appraisal') }}
                        </div>
                        <div class="p-card-title" v-if="showAppraisal">
                            [{{ mode }}] {{ $t('EPA') }}
                        </div>
                        <div class="p-card-title" v-if="this.mode == this.$FORM_MODE_HISTORY">
                            {{ $t('log_history') }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <div v-if="showAppraisal && mode != this.$FORM_MODE_VIEW" class="mr-3" style="display: flex; align-items: center; gap: 15px;">
                            <div>
                                <strong>Score:</strong> {{ header.Score ? header.Score + '%' : '-' }}
                            </div>
                            <div>
                                <strong>Rate:</strong> {{ header.Rate || '-' }}
                            </div>
                        </div>                        
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex"
                            v-if="this.fromMenu != 'Report'" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)"
                            v-if="canEdit" />
                        <Button label="Pdf" icon="pi pi-file-pdf pi-fw" class="p-button-danger mr-2"
                            @click="exportToPDF" v-if="this.mode == this.$FORM_MODE_VIEW" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
                <div class="toolCustom componentCustom" role="toolbar"
                    v-if="!showAppraisal && this.mode == this.$FORM_MODE_CREATE">
                    <div class="toolCustom-group-left">
                        <div class="alertCustom alertInfoCustom">
                            <b>{{ $t('note.create_appraisal') }}</b>
                        </div>
                    </div>
                </div>

            </template>
            <template #content>
                <div style="margin-bottom: 20px !important;">
                    <div class="p-inputtext-sm p-fluid" v-show="!this.showAppraisal" style="margin-top:40px;">
                        <div class="grid field">
                            <div class="col-6">
                                <div class="field grid">
                                    <label for="Employee_Id" class="col-3">{{ $t('name') }}<span style="color:red">*</span></label>
                                    <div class="col-9 md-9">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Employee_Id" v-if="header"
                                            :filter="true" :url="this.$API_URL + 'list/employee_id'" :minLength="0"
                                            :disabled="!canEdit || this.showAppraisal"
                                            :params="{ forAppraisal: 'true' }"
                                            :class="{ 'p-invalid': submitted && !header.Employee_Id }"
                                            @change="changeEmployee($event)" />
                                        <Skeleton v-else-if="!header" />
                                        <small
                                            v-if="header && !header.Employee_Id && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('name')) }}
                                        </small>
                                    </div>
                                </div>
                                <div class="field grid" v-if="header && layer">
                                    <div class="col-3"></div>
                                    <div class="col-9 md-9">
                                        <InputText name="Email_Employee" v-model="header.Email_Employee" required="true"
                                            type="text" :placeholder="$t('email')" v-if="header" :disabled="true" />
                                        <Skeleton v-else-if="!header" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="field grid" v-if="header && !layer">
                                    <div class="col-9 md-9">
                                        <InputText name="Email_Employee" v-model="header.Email_Employee" required="true"
                                            type="text" :placeholder="$t('email')" v-if="header" :disabled="true" />
                                        <Skeleton v-else-if="!header" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="grid field">
                            <div class="col-6">
                                <div class="field grid">
                                    <label for="NIK_Approval1" class="col-3">{{ $t('superior1') }}<span style="color:red">*</span></label>
                                    <div class="col-9 md-9">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.NIK_Approval1"
                                            v-if="header" :filter="true" :url="this.$API_URL + 'list/employee_no'"
                                            :minLength="0" :disabled="!canEdit || this.showAppraisal"
                                            :params="{ excempId: header.Employee_Id }"
                                            :class="{ 'p-invalid': submitted && !header.NIK_Approval1 }"
                                            @change="changeSuperior1($event)" />
                                        <small
                                            v-if="header && !header.NIK_Approval1 && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('superior1')) }}
                                        </small>
                                    </div>
                                </div>
                                <div class="field grid" v-if="header && layer">
                                    <div class="col-3"></div>
                                    <div class="col-9 md-9">
                                        <InputText name="Email_Approval1" v-model="header.Email_Approval1"
                                            required="true" type="text" :placeholder="$t('email')" v-if="header"
                                            :class="{ 'p-invalid': submitted && !header.Email_Approval1 }"
                                            :disabled="true" />
                                        <Skeleton v-else-if="!header" />
                                        <small
                                            v-if="header && !header.Email_Approval1 && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}
                                        </small>
                                    </div>
                                </div>
                            </div>    
                            <div class="col-6">
                                <div class="field grid" v-if="header && layer == 'SUPERIOR'">
                                    <label for="NIK_Functional" class="col-3">{{ $t('functional') }}<span style="color:red">*</span></label>
                                    <div class="col-9 md-9">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.NIK_Functional" v-if="header"
                                                    :filter="true" :url="this.$API_URL + 'list/employee_no'" :minLength="0"
                                                    :disabled="!canEdit || this.showAppraisal"
                                                    :params="{ excempId: header.Employee_Id }"
                                                    :class="{ 'p-invalid': submitted && !header.NIK_Functional }"
                                                    @change="changeFunctional($event)" />
                                        <Skeleton v-else />
                                        <small v-if="header && !header.NIK_Functional && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('functional')) }}</small>
                                    </div>
                                </div>
                                <div class="field grid" v-if="header && layer == 'SUPERIOR'">
                                    <div class="col-3"></div>
                                    <div class="col-9 md-9">
                                        <InputText name="Email_Functional" v-model="header.Email_Functional" type="text"
                                                :placeholder="$t('email')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Email_Functional }"
                                                :disabled="true" />
                                        <Skeleton v-else />
                                        <small v-if="header && !header.Email_Functional && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}</small>
                                    </div>
                                </div>
                                <div class="field grid" v-if="header && !layer">
                                    <div class="col-9 md-9">
                                        <InputText name="Email_Approval1" v-model="header.Email_Approval1"
                                            required="true" type="text" :placeholder="$t('email')" v-if="header"
                                            :class="{ 'p-invalid': submitted && !header.Email_Approval1 }"
                                            :disabled="true" />
                                        <Skeleton v-else-if="!header" />
                                        <small
                                            v-if="header && !header.Email_Approval1 && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}
                                        </small>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                        <div class="grid field">
                            <div class="col-6">
                                <div class="field grid">
                                    <label for="NIK_Approval2" class="col-3">{{ $t('superior2') }}<span style="color:red">*</span></label>
                                    <div class="col-9 md-9">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.NIK_Approval2"
                                            v-if="header" :filter="true" :url="this.$API_URL + 'list/employee_no'"
                                            :minLength="0" :disabled="!canEdit || this.showAppraisal"
                                            :params="{ excempId: header.Employee_Id }"
                                            :class="{ 'p-invalid': submitted && !header.NIK_Approval2 }"
                                            @change="changeSuperior2($event)" />
                                        <Skeleton v-else-if="!header" />
                                        <small
                                            v-if="header && !header.NIK_Approval2 && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('superior2')) }}
                                        </small>
                                    </div>
                                </div>
                                <div class="field grid" v-if="header && layer">
                                    <div class="col-3"></div>
                                    <div class="col-9 md-9">
                                        <InputText name="Email_Approval2" v-model="header.Email_Approval2"
                                            required="true" type="text" :placeholder="$t('email')" v-if="header"
                                            :class="{ 'p-invalid': submitted && !header.Email_Approval2 }"
                                            :disabled="true" />
                                        <Skeleton v-else-if="!header" />
                                        <small
                                            v-if="header && !header.Email_Approval2 && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="field grid" v-if="header && layer == 'HEAD SUPERIOR'">
                                    <label for="NIK_Functional" class="col-3">{{ $t('functional') }}<span style="color:red">*</span></label>
                                    <div class="col-9 md-9">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.NIK_Functional" v-if="header"
                                                    :filter="true" :url="this.$API_URL + 'list/employee_no'" :minLength="0"
                                                    :disabled="!canEdit || this.showAppraisal"
                                                    :params="{ excempId: header.Employee_Id }"
                                                    :class="{ 'p-invalid': submitted && !header.NIK_Functional }"
                                                    @change="changeFunctional($event)" />
                                        <Skeleton v-else />
                                        <small v-if="header && !header.NIK_Functional && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('functional')) }}</small>
                                    </div>
                                </div>
                                <div class="field grid" v-if="header && layer == 'HEAD SUPERIOR'">
                                    <div class="col-3"></div>
                                    <div class="col-9 md-9">
                                        <InputText name="Email_Functional" v-model="header.Email_Functional" type="text"
                                                :placeholder="$t('email')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Email_Functional }"
                                                :disabled="true" />
                                        <Skeleton v-else />
                                        <small v-if="header && !header.Email_Functional && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}</small>
                                    </div>
                                </div>
                                <div class="field grid" v-if="header && !layer">
                                    <div class="col-9 md-9">
                                        <InputText name="Email_Approval2" v-model="header.Email_Approval2"
                                            required="true" type="text" :placeholder="$t('email')" v-if="header"
                                            :class="{ 'p-invalid': submitted && !header.Email_Approval2 }"
                                            :disabled="true" />
                                        <Skeleton v-else-if="!header" />
                                        <small
                                            v-if="header && !header.Email_Approval2 && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}
                                        </small>
                                    </div>
                                </div>                                    
                            </div>
                        </div>

                        <div class="col-12 mt-4" v-if="this.mode == this.$FORM_MODE_HISTORY">
                            <div class="alert alert-info" v-if="this.mode == this.$FORM_MODE_HISTORY">
                                <b>{{ this.$t('note.history') }}</b>
                            </div>
                            <TabView>
                                <TabPanel>
                                    <RequestLogDataTable v-if="this.header" :modelValue="this.header.Appraisal_Logs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode">
                                    </RequestLogDataTable>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
                <ShowAppraisal :dataPdf="this.header" v-if="showAppraisal && mode != this.$FORM_MODE_VIEW" />
                <div ref="document" id="docPdf" style="background-color: white;width:595pt;">
                    <ShowPdf :dataPdf="this.header" v-if="showAppraisal && mode == this.$FORM_MODE_VIEW" />
                </div>
            </template>
        </Card>
    </form>

    <Dialog v-model:visible="isVisible" :header="$t('display_confirm')" :draggable="false" :modal="true"
        :style="{ width: this.dialogRole || this.Error_Message != '' ? '25vw' : '15vw' }" :closable="false">
        <div class="flex flex-column align-items-center p-1 surface-overlay border-round"
            v-if="this.Error_Message == ''">
            <!-- For Change Action Role -->
            <p class="mb-0" style="text-align: center;" v-if="this.dialogRole">
                {{ $t('role_change_msg') }}</p>
            <span class="font-bold text-2xl block mb-2 mt-2" v-if="this.dialogRole">
                {{ this.header.Action_Role }}</span>
            <p class="mb-0" v-if="this.dialogRole">{{ $t('change_confirm') }}</p>

            <!-- For Save Confirmation -->
            <p class="mb-0" style="text-align: center;" v-if="!this.dialogRole">
                <i class="p-confirm-popup-icon pi pi-exclamation-triangle"></i>
                {{ $t('confirm_Save') }}
            </p>
            <p></p>
            <br />
            <div class="p-confirm-popup-footer" style="margin-top: 10px;margin-right: 20px;">
                <button class="p-button p-component p-confirm-popup-reject p-button-sm p-button-text" type="button"
                    autofocus="" @click="isVisible = false">
                    <span class="p-button-label">No</span>
                    <span class="p-ink"></span>
                </button>
                &nbsp;&nbsp;
                <button class="p-button p-component p-confirm-popup-accept p-button-sm" type="button" autofocus=""
                    @click="this.saveData()">
                    <span class="p-button-label">Yes</span>
                    <span class="p-ink"></span>
                </button>
            </div>
        </div>
        <!-- For Error Message -->
        <div v-else>
            <Message severity="warn" :closable="false" v-html="this.Error_Message">
            </Message>
            <div class="p-confirm-popup-footer flex flex-column align-items-center p-1 surface-overlay border-round"
                style="margin-top: 10px;margin-right: 20px;">
                <button class="p-button p-component p-confirm-popup-accept p-button-sm p-button-text" type="button"
                    autofocus="true" @click="isVisible = false">
                    <span class="p-button-label">OK</span>
                    <span class="p-ink"></span>
                </button>
            </div>
        </div>
    </Dialog>
</template>

<script>
import ShowAppraisal from "../Appraisal/Form.vue";
import ShowPdf from "../Appraisal/FormPdf.vue";
import html2pdf from 'html2pdf.js';

export default {
    name: "Editor",
    components: {
        ShowAppraisal,
        ShowPdf
    },
    data() {
        return {
            indexName: "AppraisalIndex",
            url: this.$API_URL + "appraisal/",
            urlEmail: this.$API_URL + "util/get_email/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            showAppraisal: false,
            titleReport: "",
            fromMenu: "",
            fromTab: "",
            Error_Message: "",
            isVisible: false,
            dialogRole: false,
            layer: null, 
            answerLogId: 0,
            dataRequestLogs: [
                { field: "Action_Date", header: "Input Date" },
                { field: "Action_By", header: "User" },
                { field: "Action_Role", header: "Role" },
                { field: "Activity", header: "Activity" },
                { field: "Score", header: "Score (%)" },
                { field: "Rate", header: "Rate" },
                { field: "Result", header: "Sync Remark" },
                { field: "Action_Url", header: "Action" },
            ],
        }
    },
    methods: {
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode + "/" + this.answerLogId)
                .then((response) => {
                    if (response.data.success) {
                        self.header = response.data.data.header;
                        self.header.mode = self.mode;
                        self.header.Appraisal_Logs = response.data.data.header.Appraisal_Logs;
                        self.header.Appraisal_Log_DetailModels = response.data.data.header.Appraisal_Log_DetailModels;
                        
                        // Set layer dari header saat getData
                        self.layer = self.header.Functional_Layer;

                        if (self.mode == this.$FORM_MODE_HISTORY) {
                            this.showAppraisal = false;
                        }
                        else if (self.mode != this.$FORM_MODE_CREATE) {
                            this.showAppraisal = true;
                        }
                    }
                })
                .catch(function (error) {
                    this.showError('Error Get Data Question', error);
                });
        },
        saveData() {
            this.header.fromMenu = this.fromMenu;
            this.header.fromTab = this.fromTab;

            this.$emit('block-ui');
            this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        this.$router.push({ name: this.fromMenu, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Appraisal data has been saved successfully", life: 3000 } });
                    }
                    else {
                        this.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    this.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if (this.showAppraisal && this.mode == this.$FORM_MODE_CREATE) {
                this.showAppraisal = false;
            }
            else {
                this.$router.push({ name: this.fromMenu });
            }
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            this.Error_Message = "";

            if (!this.header.Employee_Id || !this.header.NIK_Approval1 || !this.header.NIK_Approval2 ||
                (!this.header.Email_Approval1 && this.mode == this.$FORM_MODE_CREATE) ||
                (!this.header.Email_Approval2 && this.mode == this.$FORM_MODE_CREATE) ||
                // Tambah validasi untuk NIK_Functional jika layer SUPERIOR atau HEAD SUPERIOR
                ((this.layer == 'SUPERIOR' || this.layer == 'HEAD SUPERIOR') && !this.header.NIK_Functional) ||
                ((this.layer == 'SUPERIOR' || this.layer == 'HEAD SUPERIOR') && !this.header.Email_Functional && this.mode == this.$FORM_MODE_CREATE)) {
                return;
            } else {
                if (this.showAppraisal) {
                    this.isVisible = true;

                    this.header.Procedures.forEach((e, indexE) => {
                        for (let index = 1; index <= e.Loop_Total; index++) {
                            var sect = this.header.Questions.filter(a => a.Col_Area == e.Col_Area + index)[0];
                            if (sect != undefined) {
                                if (!sect.Answer) {
                                    this.submitted = false;
                                    if (this.$store.getters.getLanguage == 'id')
                                        this.Error_Message += "<li>Soal no " + sect.Col_Area + " belum dipilih</li>";
                                    else
                                        this.Error_Message += "<li>Question no " + sect.Col_Area + " has not been selected</li>";
                                }
                            }
                        }
                    });

                    if ((this.superior || this.header.Action_Role == this.$Action_Role.Superior) &&
                        (this.header.S_Promotion || this.header.Promotion) && !this.header.S_Remark) {
                        this.submitted = false;
                        if (this.$store.getters.getLanguage == 'id')
                            this.Error_Message += "<li>Komentar diperlukan saat kolom promosi dicentang</li>";
                        else
                            this.Error_Message += "<li>Remark is required when the promotion field is checked</li>";
                    }
                    else if ((this.head || this.header.Action_Role == this.$Action_Role.Head) &&
                        !this.header.H_Remark) {
                        if (this.header.S_Promotion || this.header.Promotion) {
                            this.submitted = false;
                            if (this.header.Promotion) {
                                if (this.$store.getters.getLanguage == 'id')
                                    this.Error_Message += "<li>Komentar diperlukan saat kolom promosi dicentang</li>";
                                else
                                    this.Error_Message += "<li>Remark is required when the promotion field is checked</li>";
                            }
                            else {
                                if (this.$store.getters.getLanguage == 'id')
                                    this.Error_Message += "<li>Komentar diperlukan saat kolom promosi tidak dicentang</li>";
                                else
                                    this.Error_Message += "<li>Remark is required when the promotion field is not checked</li>";

                            }
                        }
                    }
                    else if ((this.ou_head || this.header.Action_Role == this.$Action_Role.OU_Head) &&
                        !this.header.OH_Remark) {
                        if (this.header.H_Promotion || this.header.Promotion) {
                            this.submitted = false;
                            if (this.header.Promotion) {
                                if (this.$store.getters.getLanguage == 'id')
                                    this.Error_Message += "<li>Komentar diperlukan saat kolom promosi dicentang</li>";
                                else
                                    this.Error_Message += "<li>Remark is required when the promotion field is checked</li>";
                            }
                            else {
                                if (this.$store.getters.getLanguage == 'id')
                                    this.Error_Message += "<li>Komentar diperlukan saat kolom promosi tidak dicentang</li>";
                                else
                                    this.Error_Message += "<li>Remark is required when the promotion field is not checked</li>";

                            }
                        }
                    }

                    if (this.submitted) {
                        this.Error_Message = "";

                        if (this.header.Action_Role && this.header.Action_Role.toUpperCase() != this.$store.getters.getAccount)
                            this.dialogRole = true;
                    }
                }
                else {
                    this.$confirm.require({
                        target: event.currentTarget,
                        message: this.$store.getters.getLanguage == 'id' ? 
                                (this.header.NIK_Functional ? 'Apakah Email Superior, Head Superior & Functional sudah benar ?' : 'Apakah Email Superior dan Head sudah benar ?') : 
                                (this.header.NIK_Functional ? 'Are Superior, Head Superior & Functional Emails correct ?' : 'Are Superior Emails & Head Superior Emails correct ?'),
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            this.showAppraisal = true;
                        },
                        reject: () => { }
                    });
                }
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        changeEmployee: function (e) {
            if (e == null) {
                this.header.Email_Employee = "";
                this.header.NIK_Approval1 = null;
                this.header.Email_Approval1 = null;
                this.header.NIK_Approval2 = null;
                this.header.Email_Approval2 = null;
                this.header.NIK_Functional = null; 
                this.header.Email_Functional = null; 
                this.layer = null; 
            }
            else {
                this.header.Email_Employee = e.email;
                this.layer = e.Layer; 

                if (e.NIK_Approval1) {
                    this.header.NIK_Approval1 = e.NIK_Approval1;
                    this.$axios.get(this.urlEmail + e.NIK_Approval1)
                        .then((response) => {
                            if (response.data.success)
                                this.header.Email_Approval1 = response.data.data;
                        })
                        .catch(function (error) {
                            alert(error);
                        });
                }
                else {
                    this.header.NIK_Approval1 = null;
                    this.header.Email_Approval1 = null;
                }

                if (e.NIK_Approval2) {
                    this.header.NIK_Approval2 = e.NIK_Approval2;

                    this.$axios.get(this.urlEmail + e.NIK_Approval2)
                        .then((response) => {
                            if (response.data.success)
                                this.header.Email_Approval2 = response.data.data;
                        })
                        .catch(function (error) {
                            alert(error);
                        });
                }
                else {
                    this.header.NIK_Approval2 = null;
                    this.header.Email_Approval2 = null;
                }

                if (e.NIK_Functional) {
                    this.header.NIK_Functional = e.NIK_Functional;
                    this.$axios.get(this.urlEmail + e.NIK_Functional)
                        .then((response) => {
                            if (response.data.success)
                                this.header.Email_Functional = response.data.data;
                        })
                        .catch(function (error) {
                            alert(error);
                        });
                }
                else {
                    this.header.NIK_Functional = null;
                    this.header.Email_Functional = null;
                }
            }
        },
        changeSuperior1: function (e) {
            if (e == null) {
                this.header.Email_Approval1 = "";
            }
            else {
                this.header.Email_Approval1 = e.email;
            }
        },
        changeSuperior2: function (e) {
            if (e == null) {
                this.header.Email_Approval2 = "";
            }
            else {
                this.header.Email_Approval2 = e.email;
            }
        },
        changeFunctional: function (e) {
            if (e == null) {
                this.header.Email_Functional = "";
            } else {
                this.header.Email_Functional = e.email;
            }
        },
        resetBtn() {
            this.showAppraisal = false;
        },
        exportToPDF() {
            var filename = 'Appraisal-' + this.header.Employees.Name + '-' + this.header.Period_Year;

            window.scrollTo(0, 0);
            html2pdf(this.$refs.document, {
                margin: [5, 0, 5, 0],
                filename: filename,
                // image: { type: 'jpeg', quality: 1 },
                html2canvas: {
                    scale: 2,
                    quality: 1,
                    // render independent of user's viewport, zoom, and scroll position
                    scrollX: 0,
                    scrollY: 0,
                    windowWidth: 1280,
                    width: this.$refs.document.offsetWidth,
                    onclone: (doc) => {
                        const el = doc.getElementById('docPdf');
                        if (el) {
                            el.style.overflow = 'visible';
                            el.style.width = '595pt';
                        }
                    }
                },
                // pagebreak: { mode: ['avoid-all', 'css', 'legacy'], before: '#managerialDesc' }
                pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
                jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
            })
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.fromMenu = this.$route.query.fromMenu;
        this.fromTab = this.$route.query.fromTab;
        this.answerLogId = this.$route.query.answerLogId ?? 0;        

        this.getData();
    },
    computed: {
        years() {
            let years = [];

            for (var i = new Date().getFullYear(); i <= new Date().getFullYear() + 20; i++) {
                years.push({ value: i.toString() })
            }
            return years;
        },
        canEdit() {
            return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
        },
        superior() {
            return ((this.fromTab == 0 || this.fromTab == 1) && this.header.NIK_Approval1 == this.$store.getters.getUsername) || (this.header.NIK_Approval1 == this.$store.getters.getUsername && this.mode == this.$FORM_MODE_CREATE);
        },
        head() {
            return (this.fromTab == 2 && this.header.NIK_Approval2 == this.$store.getters.getUsername) || (this.header.NIK_Approval2 == this.$store.getters.getUsername && this.mode == this.$FORM_MODE_CREATE);
        },
        ou_head() {
            return (this.fromMenu == 'AppraisalIndexAllIndex' && this.$store.getters.getAccount == this.$ACCOUNT.OU_HEAD && this.mode == this.$FORM_MODE_EDIT);
        }
    },
    mounted() {
        let bodyWidth = document.getElementsByClassName("p-card-body")[0].clientWidth;
        let clientWidth = document.body.clientWidth;
        let precentageWidth = ((bodyWidth / clientWidth) * 100) - 1;
        document.getElementsByClassName("p-toolbar")[0].style.width = '' + precentageWidth + '%';

        if (this.$store.getters.getAccount != this.$ACCOUNT.ADMIN_HO && this.$store.getters.getAccount != this.$ACCOUNT.ADMIN_UNIT && this.$store.getters.getAccount != this.$ACCOUNT.OU_HEAD && this.$store.getters.getAccount != this.$ACCOUNT.USER && (this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT))
            this.$router.push({ name: 'Denied' });
    }
}
</script>

<style scoped>
.alert-info {
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
}

.alert {
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 4px;
}

.p-toolbar {
    position: fixed !important;
    z-index: 100 !important;
}

.toolCustom {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0.5rem;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 3px;
}

.componentCustom {
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 1rem;
    font-weight: normal;
    box-sizing: border-box;
    padding-top:55px;
    margin-bottom: -55px;
}

.toolCustom-group-left {
    align-items: center;
}

.alertCustom {
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
}

.alertInfoCustom {
    color: #31708f;
    background-color: #d9edf7;
}
</style>